import { EncryptionType, Platform } from '@foundation-player/runtime';
import { TransformPlayerConfig } from './transform-player-config';

/**
 * This function adds the preferred key system aka DRM to the player config.
 */
export const addPreferredKeySystems: TransformPlayerConfig = (
  _partialBuilderConfig,
  playerConfig,
  _clientAndScope,
  _environment,
  platform,
) => {
  return {
    ...playerConfig,
    preferredKeySystems: getPreferredKeySystemsForPlatform(platform),
  };
};

function getPreferredKeySystemsForPlatform(platform: Platform | undefined): EncryptionType[] {
  switch (platform) {
    case Platform.MagentaG3:
    case Platform.MagentaG4:
    case Platform.MagentaG5:
    case Platform.SkyQ:
      return [EncryptionType.PlayReady];

    case Platform.SkyXiOne:
    case Platform.SkyStream:
    case Platform.Tizen3:
    case Platform.Tizen4:
    case Platform.Tizen5:
    case Platform.Tizen5_5:
    case Platform.Tizen6:
    case Platform.Tizen6_5:
    case Platform.Tizen7:
    case Platform.Tizen8:
    case Platform.WebOS3:
    case Platform.WebOS4:
    case Platform.WebOS5:
    case Platform.WebOS6:
    case Platform.WebOS22:
    case Platform.WebOS23:
    case Platform.WebOS24:
    case Platform.WebOS25:
    case Platform.VodafoneGTV:
    case Platform.VodafoneVTV:
    case Platform.Chromecast:
    case Platform.TeleColumbus:
    case Platform.Kepler:
      return [EncryptionType.Widevine];

    default:
      return [EncryptionType.Widevine, EncryptionType.PlayReady, EncryptionType.FairPlay];
  }
}
